<template>
    <DrawerHandler :disable="isModal">
        <div class="position-sticky d-flex flex-column" :class="isModal ? 'bg-white' : 'bg-normal'"
             style="z-index: 200">
            <LoadRateOperationDetail v-if="!isModal"></LoadRateOperationDetail>
            <div class="d-flex flex-row ">
                <el-input
                    placeholder="工单搜索"
                    class="m-1 w-100 pr-1 h-25"
                    v-model="searchInput"
                    @change="handleSearch"
                    clearable>
                </el-input>
                <AvatarButton class="m-auto" icon="el-icon-paperclip" title="锁定工单列表"
                              :show-corner="headerListTempLock"
                              corner-icon="fa-lock"
                              @btnClick="$store.commit('calendarShift/setHeaderListTempLock',!headerListTempLock)"></AvatarButton>
            </div>
        </div>

        <el-collapse
            v-show="headerIdList.length > 0"
            class="cover"
            :value="operationCollapseValue"
            @change="selectHeader"
            :class="isModal ? 'w-100' : 'w-300px'">
            <el-collapse-item
                v-for="(id,index) in headerIdList"
                :name="id"
                :id="id"
                :key="index">
                <template slot="title">
                    <div class="d-flex flex-row">
                        <i v-if="selectedHeaderIdSet.has(id)" class="fa fa-check-circle color-green"
                           aria-hidden="true"></i>
                        <div :class="selectedHeaderIdSet.has(id) ? 'ml-0' : 'ml-18rem'" class="text-nowrap">
                            {{ headerMap[id].projectCode }}/{{ headerMap[id].materialDescription }}
                        </div>
                        <div class="position-sticky d-flex flex-row" style="right: 1rem">
                            <i v-if="selectedOperationId!==''&&operationMap[selectedOperationId].prdPpHeaderId===id"
                               class="fa fa-bookmark color-purple"
                               aria-hidden="true"></i>
                            <i v-if="joinHeaderIdSet.has(id)" class="fa fa-tag color-orange" aria-hidden="true"></i>
                        </div>
                    </div>
                </template>
                <div class="d-flex flex-column">
                    <KeyValueCell horizontal :value="headerMap[id].id">id</KeyValueCell>
                    <KeyValueCell horizontal :value="headerMap[id].orderCode">工单编号</KeyValueCell>
                    <KeyValueCell horizontal :value="headerMap[id].projectCode">项目号</KeyValueCell>
                    <KeyValueCell horizontal :value="headerMap[id].projectName">项目名称</KeyValueCell>
                    <KeyValueCell :value="headerMap[id].materialDescription">物料描述</KeyValueCell>
                    <KeyValueCell horizontal :value="headerMap[id].prdPpStatusName">工单状态</KeyValueCell>
                    <KeyValueCell horizontal :value="headerMap[id].isLocked?'已锁定':'未锁定'">锁定状态</KeyValueCell>
                    <KeyValueCell :value="headerMap[id].systemStatus">System Status</KeyValueCell>
                    <KeyValueCell horizontal :value="headerMap[id].wbsCode">WBS编号</KeyValueCell>
                    <KeyValueCell horizontal :value="headerMap[id].forecastBeginTime">计划开始时间</KeyValueCell>
                    <KeyValueCell horizontal :value="headerMap[id].forecastFinishTime">计划结束时间</KeyValueCell>
                    <el-collapse class="cover">
                        <el-collapse-item>
                            <template slot="title">
                                <button type="button" class="btn btn-light w-100">工序</button>
                            </template>
                            <div v-for="item in operationCollection.get(id)"
                                 :key="item.id"
                                 class="badge cursor-pointer"
                                 :class="selectedOperationId===item.id?'badge-success':'badge-light'"
                                 @click="operationSelect(item.id)">
                                {{ item.operationSeq }}
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </el-collapse-item>
        </el-collapse>

        <empty-list-info v-if="headerIdList.length===0" class="mt-2"></empty-list-info>

    </DrawerHandler>
</template>

<script>
import DrawerHandler from "@/components/echarts-part/CalendarShift/cells/stuffs/DrawerHandler";
import KeyValueCell from "@/views/sithMes/prd/PrdOperationExcute/cells/KeyValueCell";
import {mapState} from "vuex";
import LoadRateOperationDetail from "@/components/echarts-part/CalendarShift/cells/LoadRateOperationDetail";
import AvatarButton from "@/components/echarts-part/CalendarShift/cells/stuffs/AvatarButton";
import EmptyListInfo from "@/components/echarts-part/CalendarShift/cells/stuffs/EmptyListInfo";

export default {
    name: "LoadRateHeaderList",
    components: {EmptyListInfo, LoadRateOperationDetail, KeyValueCell, DrawerHandler, AvatarButton},
    props: {
        pp_header_ids: {
            type: Array
        },
        isModal: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            //工序map于工单
            operationCollection: new Map(),
            operationCollapseValue: null,
            headerIdList: [],
            searchInput: '',
        }
    },
    computed: {
        ...mapState({
            selectedOperationId: state => state.calendarShift.selectedOperationId,
            selectedHeaderIdSet: state => state.calendarShift.selectedHeaderIdSet,
            joinHeaderIdSet: state => state.calendarShift.joinHeaderIdSet,
            displayJoinHeader: state => state.calendarShift.displayJoinHeader,
            headerListTempLock: state => state.calendarShift.headerListTempLock,
            needScrollToHeader: state => state.calendarShift.needScrollToHeader,
        }),
        headerMap() {
            return this.$store.getters["calendarShift/headerMap"];
        },
        operationMap() {
            return this.$store.getters["calendarShift/operationMap"];
        },
        ppHeaderIds() {
            if (this.pp_header_ids === undefined) {
                let tempList = [];
                for (let id in this.headerMap) {
                    if (this.headerMap.hasOwnProperty(id)) {
                        tempList.push(Number.parseInt(id));
                    }
                }
                return tempList;
            } else {
                return this.pp_header_ids;
            }
        }
    },
    mounted() {
        this.operationCollapseValue = Array.from(this.selectedHeaderIdSet);
        this.handleSearch();
    },
    watch: {
        pp_header_ids: {
            handler() {
                this.initOperationCollection();
                this.handleSearch();
            },
            immediate: true
        },
        displayJoinHeader() {
            this.handleSearch();
        },
        needScrollToHeader(val) {
            if (val && this.selectedOperationId !== '') {
                let opId = this.operationMap[this.selectedOperationId].prdPpHeaderId;
                let el = document.getElementById(opId);
                if (el != null) {
                    el.scrollIntoView({block: 'center', behavior: 'smooth'})
                }
                this.$store.commit('calendarShift/setNeedScrollToHeader', false);
            }
        }
    },
    methods: {
        handleSearch() {
            let reg = new RegExp(".*" + this.searchInput + ".*", "i");
            let tempList = [];
            for (let id of this.ppHeaderIds) {
                let headerItem = this.headerMap[id];
                if (this.displayJoinHeader && !this.joinHeaderIdSet.has(id)) {
                    continue;
                }
                if (reg.test(headerItem.projectCode) || reg.test(headerItem.projectName) || reg.test(headerItem.orderCode) || reg.test(headerItem.materialDescription)) {
                    tempList.push(id);
                }
            }
            this.headerIdList = tempList;

            if (!this.isModal) {
                let tempLocationIdSet = null;
                if (this.searchInput != null && this.searchInput !== '') {
                    tempLocationIdSet = new Set();
                    for (let id of tempList) {
                        let opList = this.operationCollection.get(id);
                        for (let op of opList) {
                            tempLocationIdSet.add(op.actualMstLocationId + "");
                        }
                    }
                }
                this.$store.commit('calendarShift/setShowLocationIdSet', tempLocationIdSet);
            }
        },
        selectHeader(id) {
            this.$store.commit('calendarShift/setSelectedHeaderIdSet', id);
        },
        initOperationCollection() {
            this.operationCollection = new Map();
            let headerIdSet = new Set(this.ppHeaderIds);
            for (let id in this.operationMap) {
                if (this.operationMap.hasOwnProperty(id)) {
                    let opId = this.operationMap[id].prdPpHeaderId;
                    if (headerIdSet.has(opId)) {
                        if (this.operationCollection.has(opId)) {
                            this.operationCollection.get(opId).push(this.operationMap[id]);
                        } else {
                            let tempList = [];
                            tempList.push(this.operationMap[id]);
                            this.operationCollection.set(opId, tempList);
                        }
                    }
                }
            }
            //按工序号排序
            for (let key of this.operationCollection.keys()) {
                let value = this.operationCollection.get(key);
                value.sort((a, b) => {
                    let an = Number.parseInt(a.operationSeq);
                    let bn = Number.parseInt(b.operationSeq);
                    return an - bn;
                });
            }
        },
        operationSelect(id) {
            if (id !== this.selectedOperationId) {
                this.$store.dispatch('calendarShift/selectOperation', id)
            }
            this.$store.commit('calendarShift/setNeedScroll', true);
        }
    }
}
</script>

<style scoped>
.color-green {
    color: #28a745;
}

.color-purple {
    color: #cb42f5;
}

.color-purple, .color-orange.fa {
    font-size: 1.2rem;
    margin: auto 0.3rem;
}

.color-green.fa {
    font-size: 1.2rem;
    margin: auto 0.3rem;
    position: relative;
    left: 0;
}

.color-orange {
    color: #ffa500;
}

.ml-18rem {
    margin-left: 1.8rem;
}

.cover {
}

.cover >>> .el-collapse-item__content {
    padding-bottom: 8px;
    padding-left: 8px;
}

.w-300px {
    width: 300px;
}

.position-sticky.bg-normal {
    top: 0;
}
</style>